import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import es from 'vuetify/src/locale/es.ts'

Vue.use(Vuetify)

const opts = {
    breakpoint: {
        thresholds: {
            xs: 340,
            sm: 540,
            md: 600,
            lg: 1280,
        },
        scrollBarWidth: 24,
    },
    lang: {
        locales: { es },
        current: 'es',
    },
}

export default new Vuetify(opts)